import styled from "styled-components"

export const ButtonMarginTop = styled.button`
  margin-top: 0.5rem;
`
